import { Directive, TemplateRef } from "@angular/core";

@Directive({ selector: "[radrQueryRemoveButton]" })
export class QueryRemoveButtonDirective {
  constructor(public template: TemplateRef<any>) {}
}
